import api from './api';

const disciplinesApi = {
  /**
   * Get all available disciplines and their sub-disciplines.
   * @returns {Promise<Object>} The API response.
   */
  getDisciplines: () => {
    return api.get('/disciplines');
  },
};

export default disciplinesApi;